module.exports = __webpack_public_path__ + "static/vestcolours-e255cc12a0b774d452bb26ba2330d92f.jpeg";